module.exports = __webpack_public_path__ + "img/qita.b7b2d648.png";